(function () {
    "use strict";

    angular.module("app").controller("ExternalInstallationRequestController", ExternalInstallationRequestController);

    ExternalInstallationRequestController.$inject = ["controllerDecorator", "externalInstallationRequestApi",];
    function ExternalInstallationRequestController(controllerDecorator, externalInstallationRequestApi,) {

        const context = { RequestId: null, };
        const vm = this;
        controllerDecorator.Decorate(vm, ["comments", "dialog"]);

        vm.request = null;

        vm.States = [{ Key: '10' }, { Key: '40' }, { Key: '51' }, { Key: '60' }, { Key: '130' }, { Key: '140' }, { Key: '160' }, { Key: '170' }];

        function initialize() {
            const parsed = vm.ParsePrettyUrl();
            context.RequestId = parsed.id;

            if (!!context.RequestId)
                load();
        }

        function load() {
            externalInstallationRequestApi.get(context.RequestId)(
                data => {
                    vm.request = data;
                    vm.Comments.Initialize({ RequestId: context.RequestId, DossierId: null, OrganisationId: vm.request.Organisation.PublicId, ICD: vm.request.ScreeningBy });
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        initialize();
    }
})();
